module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-cognac-022-1200x2490.1a237351.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-cognac-022-1200x2490.jpg
// module id = 1105
// module chunks = 37